import axios from 'axios';
import authHeader from './auth.header';
import { MAX_UPLOAD_FILE_SIZE } from '../config';

export default class UploadService {
  async uploadMediaAndGetResponse(files) {
    const responses = [];
    await Promise.all(files.map(async (file) => {
      await this.uploadFile(file).then((response) => {
        responses.push(response.data);
      }).catch(() => {
        responses.push({ error: true });
      });
    }));
    return responses;
  }

  uploadFile = (fileItem) => {
    return new Promise((resolve, reject) => {
      const fileName = fileItem.fileName ? fileItem.fileName : fileItem.file.name;
      const headers = {
        ...authHeader(),
        'Content-Type': fileItem.file.type,
        'Content-Disposition': `form-data; name="file"; filename="${fileName}"`,
      };
      axios.post(`${process.env.VUE_APP_API_URL}/media`, fileItem.file, { headers })
        .then((result) => {
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  isMimeTypeValid = (file, acceptedMimeTypes) => {
    return acceptedMimeTypes.includes(file.type);
  }

  isFileSizeValid = (file) => {
    return file.size <= MAX_UPLOAD_FILE_SIZE;
  }
}
